const topics = [
  { label: '#院线大片', hot: true },
  { label: '#国产剧热播', hot: true },
  { label: '#韩剧更新', hot: true },
  { label: '#综艺爆笑', hot: false },
  { label: '#美剧回归', hot: true },
  { label: '#日漫新番', hot: false },
  { label: '#悬疑推理', hot: false },
  { label: '#甜宠爱情', hot: true },
  { label: '#科幻巨制', hot: false },
  { label: '#纪录片精选', hot: false },
  { label: '#经典重温', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-500">大家都在讨论的影视话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-xs w-4 h-4 flex items-center justify-center"></i>
              )}
              {topic.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}